// mockData.js
export const posts = [
  {
    id: 1001,
    title: 'React入门指南',
    content: '# React入门指南\n\nReact是一个用于构建用户界面的JavaScript库...',
    summary: '学习React的基础知识，开始构建现代化的Web应用程序。',
    author: '张三',
    date: '2023-10-15',
    category: '前端开发',
    tags: ['react', 'javascript', '前端'],
    readTime: '5 分钟',
    image: 'https://via.placeholder.com/600x400',
    isPublished: true
  },
  {
    id: 1002,
    title: '掌握JavaScript ES6+新特性',
    content: '## ES6引入了许多强大的功能...',
    summary: '探索每个JavaScript开发者都应该了解的最新功能。',
    author: '李四',
    date: '2023-10-10',
    category: 'JavaScript',
    tags: ['javascript', 'es6', 'web开发'],
    readTime: '8 分钟',
    image: 'https://via.placeholder.com/600x400',
    isPublished: true
  }
];

export const categories = ['前端开发', 'JavaScript', 'Node.js', 'CSS', 'HTML', 'Web开发', 'React', 'Vue'];

export const tags = ['技术', '编程', 'React', 'JavaScript', '前端', '后端', '设计', '生活', '教程', '开源'];

// 模拟用户数据
export const users = [
  {
    id: 1,
    username: 'admin',
    email: 'admin@example.com',
    password: 'password123',
    role: 'admin'
  },
  {
    id: 2,
    username: 'user1',
    email: 'user1@example.com',
    password: 'password123',
    role: 'user'
  }
];